/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2022 
	24-01-2022
	- [CHANGE] Maybe better audio player now
2021
	19-11-2021
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_digidag_audioplayer = {};

(function(){

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		/*
		Reset tracker
		*/
		var circle 						= document.querySelector('circle');
		var radius 						= circle.r.baseVal.value;
		var circumference 				= radius * 2 * Math.PI;

		$('.circle-1').css({
			'strokeDasharray'	: circumference + ' ' + circumference,
			'strokeDashoffset'  : circumference
		});

		/*
		Listeners: Bind
		*/
		$(document).on('click','.js-audioplayer-control',function() {
			specific_digidag_audioplayer.togglePlayingPause();
		});
		
	};
		
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	/*
	Toggle: Play and pause
	Toggle: Play and pause
	Toggle: Play and pause
	Toggle: Play and pause
	*/
	this.togglePlayingPause = function(
		w,
		playing
	) {

		/*
		If: Playing, set variable
		*/
		if(playing == 1) {
			$('.js-audioplayer-pausedwhenplaying').val('yes');
		} else {
			$('.js-audioplayer-pausedwhenplaying').val('no');
		}

		/*
		Go on
		*/
		if(w == 0) {

			/*
			Pause
			*/
			$('.js-audioplayer').find('.play').removeClass('hidden');
			$('.js-audioplayer').find('.pause').addClass('hidden');

			/*
			Set
			*/
			$('.js-audioplayer-playing').val('false');

			/*
			Pause
			*/
			specific_digidag_audioplayer.pause();
			
		} else {

			if(
				$('.js-audioplayer-playing').val() == 'false'
			) {

				/*
				Play
				*/
				if(_isDigidagDebug == 0) {
					specific_digidag_audioplayer.play();
				}

			} else {

				/*
				Pause
				*/
				specific_digidag_audioplayer.pause();

			}

		}

	};

	/*
	Set: Played
	*/
	this.setPlayed = function( 
		which,
		what
	) {

		var _audioplayer_isplayed 			= $('.js-audioplayer-played').val();
		var _audioplayer_isplayed_array 	= _audioplayer_isplayed.split(',');

		_audioplayer_isplayed_array[which]  = 1;

		_string = _audioplayer_isplayed_array.toString;

		/*
		Set: Input value
		*/
		$('.js-audioplayer-played').val(_audioplayer_isplayed_array);


	};

	/*
	Load file
	Load file
	Load file
	Load file
	*/
	this.load = function(
		file,
		_url,
		_counter
	) {

		var _audioplayer = $('.js-audioplayer-file')[0];

		/*
		Playing: Reset
		*/
		$('.js-audioplayer-playing').val('false');

		/*
		Load file
		*/
		var _file = globalUrl + '/doc/static/' + file;

		_audioplayer.src = _file;
		_audioplayer.load();

		/*
		Set total time
		*/
		_audioplayer.addEventListener("loadedmetadata", function() {
			
			$('.js-audioplayer-totaltime').val(_audioplayer.duration);

			/*
			Set: Total time
			*/
			specific_digidag_audioplayer.setTotalTime(0);

			/*
			Play or not?
			*/
			_audioplayer.addEventListener("canplay",function(){
				
				/*
				Pause
				*/
				// _audioplayer.pause();

				/*
				Audioplayer
				*/
				var _audioplayer_isplayed 			= $('.js-audioplayer-played').val();
				var _audioplayer_isplayed_array 	= _audioplayer_isplayed.split(',');

				/*
				Audioplayer: Play or not?
				*/
				if(
					_audioplayer_isplayed_array[(_counter-1)] == 0 &&
					$('.js-audioplayer-playing').val() == 'false' &&
					url[2] == _url
				) {

						/*
						Play
						*/
						specific_digidag_audioplayer.togglePlayingPause();

						/*
						Set: as played
						*/
						specific_digidag_audioplayer.setPlayed((_counter-1),1);					

				} else {

					specific_digidag_audioplayer.togglePlayingPause(0);
					
				}

			});

		});

		/*
		Show
		*/
		specific_digidag_audioplayer.toggleVisibleOnOff('on');

	};

	/*
	*/
	this.switchAudio = function(
		_file,
		_url,
		_counter
	) {

		/*
		Load
		*/
		specific_digidag_audioplayer.load(
			_file + '?v=' + Math.floor(Math.random() * 100) + 1,
			_url,
			_counter
		);	

	};

	/*
	Toggle: Visibility
	Toggle: Visibility
	Toggle: Visibility
	Toggle: Visibility
	*/
	this.toggleVisibleOnOff = function(
		w
	) {

		switch(w) {
			case 'on':

				/*
				Show: Audio
				*/
				$('.js-audioplayer').fadeIn(800);

			break;

			case 'off':

				/*
				Show: Audio
				*/
				$('.js-audioplayer').fadeOut(800);

			break;
		}

	};

	/*
	Progress
	Progress
	Progress
	Progress
	*/
	this.progress = function(
		percent
	) {

		var circle 						= document.querySelector('circle');
		var radius 						= circle.r.baseVal.value;
		var circumference 				= radius * 2 * Math.PI;

		const offset 					= circumference - percent / 100 * circumference;

		$('.circle-1').css({
			'strokeDashoffset' : offset
		});

	};

	/*
	Total time
	*/
	this.setTotalTime = function(
		_time
	) {

		var _totaltime 		= $('.js-audioplayer-totaltime').val();
		var _totalplayed 	= _time;

		var mins = Math.floor((_totaltime - _totalplayed) / 60);
			// if (mins < 10) {
			// //mins = '0' + String(mins);
			// }
		var secs = Math.floor((_totaltime - _totalplayed) % 60);
			if (secs < 10) {
				secs = '0' + String(secs);
			}

		  $('.js-audioplayer').find('.timer').html(
		  	mins + ':' + secs
		  );

	};

	/*
	Play
	Play
	Play
	Play
	*/
	this.play = function() {

		/*
		Trigger
		*/
		$('.js-audioplayer-file').trigger('play');

		/*
		Play
		*/
		$('.js-audioplayer').find('.play').addClass('hidden');
		$('.js-audioplayer').find('.pause').removeClass('hidden');

		/*
		Set
		*/
		$('.js-audioplayer-playing').val('true');

		/*
		Update timer
		*/
		setInterval(function () {
		  
		  var _track 			= $('.js-audioplayer-file')[0];
		  var _time 			= _track.currentTime;
		  var _totaltime 		= $('.js-audioplayer-totaltime').val();

		  specific_digidag_audioplayer.setTotalTime(_time);

		  /*
		  Update percentage
		  */
		  var _percentage = (_track.currentTime / _totaltime * 100);

		  /*
		  Progress
		  */
		  specific_digidag_audioplayer.progress(
		  	_percentage
		  );

		  /*
		  End? Reset
		  */
		  if(_percentage == 100) {

		  	/*
		  	Track to zero
		  	*/
		  	_track = 0;

			/*
			Progress
			*/
			specific_digidag_audioplayer.progress(0);

		  	/*
		  	Turn to play
		  	*/
		 	specific_digidag_audioplayer.togglePlayingPause(0);	

		 	/*
		 	0:00
		 	*/
		 	$('.js-audioplayer').find('.timer').html(
			  	'0:00'
			);

		  }

		}, 100);

	};

	/*
	Pause
	Pause
	Pause
	Pause
	*/
	this.pause = function() {

		/*
		Pause
		*/
		$('.js-audioplayer-file').trigger('pause');
		
		/*
		Pause
		*/
		$('.js-audioplayer').find('.play').removeClass('hidden');
		$('.js-audioplayer').find('.pause').addClass('hidden');

		/*
		Set
		*/
		$('.js-audioplayer-playing').val('false');

	};

}).apply(specific_digidag_audioplayer); 